import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ThemeLayoutModule } from './theme-layout/theme-layout.module';
import { LicensingModule } from './licensing/licensing.module';
// import { SharedModule } from './shared/shared.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { HttpClientModule } from '@angular/common/http';
import { ConfirmDialogComponent } from './_helpers/confirm-dialog/confirm-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ToastrModule } from 'ngx-toastr';
import { LoginComponent } from './login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RegisterComponent } from './register/register.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

@NgModule({
  declarations: [
    AppComponent,
    ConfirmDialogComponent,
    LoginComponent,
    RegisterComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent
  ],
  imports: [
    ThemeLayoutModule,
    RouterModule.forRoot([]),
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule,
    LicensingModule,
    ModalModule.forRoot(),
    HttpClientModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    // SharedModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right',
      timeOut:3000,
      iconClasses:{
        error: 'toast-error',
        info: 'toast-info',
        success: 'toast-success',
        warning: 'toast-warning',
      },
      messageClass: 'toast-message'
    }),
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
